import React from 'react';

const VolunterRemoveConfrim = ({ 
  isOpen, 
  onClose, 
  onConfirm, 
  title, 
  message, 
  confirmText = "Confirm", 
  cancelText = "Cancel",
  isLoading = false 
}) => {
  if (!isOpen) return null;

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div
      onClick={handleOverlayClick}
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1100,
        backdropFilter: "blur(3px)",
      }}
    >
      <div
        style={{
          background: "#FFFFFF",
          borderRadius: "16px",
          width: "90%",
          maxWidth: "380px",
          padding: "24px",
          boxShadow: "0 20px 40px rgba(0,0,0,0.2)",
          animation: "modalSlideIn 0.2s ease",
        }}
      >
        <h3 style={{ 
          margin: "0 0 12px 0", 
          color: "#0B1C33", 
          fontSize: "1.3rem",
          fontWeight: 600 
        }}>
          {title}
        </h3>
        <p style={{ 
          margin: "0 0 24px 0", 
          color: "#6F7D95", 
          fontSize: "1rem",
          lineHeight: "1.5" 
        }}>
          {message}
        </p>
        <div style={{ 
          display: "flex", 
          gap: "12px", 
          justifyContent: "flex-end" 
        }}>
          <button
            onClick={onClose}
            disabled={isLoading}
            style={{
              padding: "10px 20px",
              background: "transparent",
              border: "1px solid #E9EDF4",
              borderRadius: "8px",
              color: "#6F7D95",
              fontSize: "0.95rem",
              fontWeight: 500,
              cursor: isLoading ? "not-allowed" : "pointer",
              transition: "all 0.2s",
              opacity: isLoading ? 0.6 : 1,
            }}
            onMouseEnter={(e) => {
              if (!isLoading) {
                e.currentTarget.style.background = "#F8FAFE";
              }
            }}
            onMouseLeave={(e) => {
              if (!isLoading) {
                e.currentTarget.style.background = "transparent";
              }
            }}
          >
            {cancelText}
          </button>
          <button
            onClick={onConfirm}
            disabled={isLoading}
            style={{
              padding: "10px 20px",
              background: "#DC2626",
              border: "none",
              borderRadius: "8px",
              color: "white",
              fontSize: "0.95rem",
              fontWeight: 500,
              cursor: isLoading ? "not-allowed" : "pointer",
              transition: "all 0.2s",
              opacity: isLoading ? 0.6 : 1,
            }}
            onMouseEnter={(e) => {
              if (!isLoading) {
                e.currentTarget.style.background = "#B91C1C";
              }
            }}
            onMouseLeave={(e) => {
              if (!isLoading) {
                e.currentTarget.style.background = "#DC2626";
              }
            }}
          >
            {isLoading ? "Removing..." : confirmText}
          </button>
        </div>
      </div>

      <style>
        {`
          @keyframes modalSlideIn {
            from {
              opacity: 0;
              transform: translateY(20px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }
        `}
      </style>
    </div>
  );
};

export default VolunterRemoveConfrim;